var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-item-root-container",style:({
    'background-image':
      'url(' +
      (_vm.dataSource.img_url ? _vm.dataSource.img_url : _vm.icons.boardBackground) +
      ')',
  })},[_c('div',{staticClass:"board-item-mask"}),_c('span',{staticStyle:{"z-index":"1","color":"#fff","font-weight":"bold","font-size":"15px"}},[_vm._v(_vm._s(_vm.dataSource.name))]),_c('Icon',{staticStyle:{"align-self":"flex-end","z-index":"1"},attrs:{"type":"md-star","color":_vm.isStar ? '#f0c347' : '#999',"size":20},on:{"click":function($event){$event.stopPropagation();return _vm.setTop.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }